import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import styles from "./InvoiceContentDialog.module.scss";
import InputGroup from "../../core/InputGroup";
import { InvoiceContentRequest } from "../../../apis/models/InvoiceContentRequest";
import DropdownCellOptions from "../../core/DropdownCellOptions";
import { BrandlistResponseData } from "../../../apis/models/BrandlistResponse";
import { InvoiceMasterData } from "../../../apis/models/InvoiceMasterRequest";
import { format } from "date-fns";

const InvoiceContentDialog: React.FC<InvoiceContentDialogProps> = (props: InvoiceContentDialogProps) => {
    const {open, onClose, onSave, targetBrand, targetInvoice} = props;
    const initialItem: InvoiceContentRequest = {
      invoiceMasterId: "",
      name: "",
      totalPrice: 0,
      description: "",
      quantity: 0,
      unitPrice: 0,
      order: 0
    }
    const [dialogData, setDialogData] = React.useState<InvoiceContentRequest[]>([initialItem]);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [hovering, setHovering] = React.useState<boolean>(false);
    const [focusing, setFocusing] = React.useState<boolean>(false);


    const handleInputChange = (item: InvoiceContentRequest, index: number) => {
        const copyData = [...dialogData];
        copyData.splice(index, 1, item);
        setDialogData(copyData);
    }

    const deleteItem = (item: number) => {
        const copyData = [...dialogData];
        copyData.splice(item, 1);
        setDialogData(copyData);
    }

    const handlePickOption = (opt: string, alias: "oppTape" | "tsubo") => {
        if (!anchorEl) { return }
        const index = (anchorEl as HTMLInputElement).name;
        if (!index || index === undefined || isNaN(parseInt(index))) { return }
        handleInputChange({...dialogData[parseInt(index)], name: opt, nameAlias: alias}, parseInt(index));
        setAnchorEl(null);
    }
    
    const invoicePeriod = React.useMemo(() => {
      if (targetInvoice){
        return `${format(new Date(targetInvoice.from), "yyyy/MM/dd")} ～ ${format(new Date(targetInvoice.to), "yyyy/MM/dd")}`
      }
      return ''
    }, [targetInvoice])

    return (
        <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="md">
            <DialogTitle sx={{fontWeight: 700, fontSize: "24px", paddingBottom: "40px"}}>{targetBrand?.brandName ?? ''} - 請求項目追加</DialogTitle>
            <DialogContent sx={{padding: "0 40px 24px"}}>
                <div className={styles.dialog__label}>
                  <span>請求期間：</span>
                  <span className={styles.dialog__label_content}>{invoicePeriod}</span>
                </div>
                <div className={styles.dialog__content}>
                  {
                    dialogData.map((item, index) => (
                      <div className={styles.dialog__content_row} key={index}>
                          <InputGroup label="項目名" required type="text" onChange={(val) => handleInputChange({...item, name: val, nameAlias: undefined}, index)} name={index.toString()}
                            value={item.name} handleFocus={(e) => {setAnchorEl(e.currentTarget); setFocusing(true)}} handleBlur={() => setFocusing(false)}/>
                          <InputGroup label="数量" required type="number" onChange={(val) => handleInputChange({...item, quantity: val, totalPrice: item.unitPrice && item.unitPrice !==undefined ? item.unitPrice * val : 0}, index)} value={item.quantity !== undefined ? item.quantity : 0}/>
                          <InputGroup label="単価" required type="number" onChange={(val) => handleInputChange({...item, unitPrice: val, totalPrice: item.quantity && item.quantity !==undefined ? item.quantity * val : 0}, index)} value={item.unitPrice !== undefined ? item.unitPrice : 0}/>
                          <InputGroup label="摘要" type="text" onChange={(val) => handleInputChange({...item, description: val}, index)} value={item.description}/>
                          <CloseIcon className={styles.dialog__content_row_icon} onClick={() => deleteItem(index)}/>
                      </div>
                    ))
                  }
                </div>
                <DropdownCellOptions
                    anchorEl={anchorEl}
                    focusing={focusing}
                    onChangeAnchor={(val) => setAnchorEl(val)}
                    onHover={(val) => setHovering(val)}
                >
                    <div className={styles.options}>
                        <div onClick={() => handlePickOption("OPPテープ", "oppTape")}>OPPテープ</div>
                        <div onClick={() => handlePickOption("坪数", "tsubo")}>坪数</div>
                    </div>
                </DropdownCellOptions>
                <div className={styles.dialog__add}>
                    <Button variant="outlined" color="primary" onClick={() => {setDialogData([...dialogData, initialItem])}}>＋行追加</Button>
                </div>
                <div className={styles.dialog__functions}>
                    <Button variant="outlined" color="primary" onClick={() => {setDialogData([initialItem]); onClose()}}>キャンセル</Button>
                    <Button 
                        variant="contained" color="primary" onClick={() => {onSave(dialogData); onClose()}} 
                        disabled={!dialogData.every(item => item.name !== "" && item.unitPrice !== 0 && item.quantity !== 0)}
                    >登録</Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default InvoiceContentDialog;

export type InvoiceContentDialogProps = {
    open: boolean,
    onClose: () => void,
    onSave: (val: InvoiceContentRequest[]) => void,
    targetBrand?: BrandlistResponseData,
    targetInvoice?: InvoiceMasterData,
}